module.exports = __webpack_public_path__ + "img/shadow_extra_heart_mask.3f343721.png";